<script setup lang="ts">
import { useConnectivityToast } from "@/composables/global/useConnectivityToast"
useConnectivityToast()
</script>
<template></template>